import classes from './Header.module.css';
import { HDate } from 'hebcal';
import moment from 'moment/moment';
import { useEffect, useState } from 'react';

function Header({ station }) {
    const engDate = moment().format('DD/MM/yyyy');
    const hebDate = new HDate(new Date()).toString('h');
    const [curTime, setCurTime] = useState(moment().format('HH:mm'));

    useEffect(() => {
        console.log('working...');

        const interval = setInterval(() => {
            setCurTime(moment().format('HH:mm'));
        }, 1000 * 60);
        return () => {
            clearInterval(interval);
        };
    }, []);

    const handleStationName = (name) => {
        return (
            <div style={{ display: 'block', justifyItems: 'center' }}>
                <h1>{name.split('-')[0]}</h1>
                <h1>{name.split('-')[1]}</h1>
            </div>
        );
    };

    return (
        <div className={classes.header}>
            <div className={classes['header-layout']}>
                <div className={classes.dates}>
                    <h2>{engDate}</h2>
                    <h2>{hebDate}</h2>
                    <h2>{curTime}</h2>
                </div>
                <div className={classes.studio}>
                    {station.split('-').length > 1 ? handleStationName(station) : <h1>{station}</h1>}
                </div>
                <div className={classes.logo}>
                    <img src={'https://upload.wikimedia.org/wikipedia/commons/1/13/Kan_logo_full_text.svg'} alt="KAN 11 LOGo" />
                </div>
            </div>
        </div>
    );
}

export default Header;
